@if (edittedOrgUnitSetting) {
  <a class="back-button" (click)="back()">
    <svg class="arrow" alt="Arrow" xmlns="http://www.w3.org/2000/svg" width="17" height="9" viewBox="0 0 17 9">
      <g id="arrow_-foward_-go_-right" data-name="arrow,-foward,-go,-right" transform="translate(-1 -8.293)">
        <path id="Path" d="M13.547,8.293,18,12.793l-4.453,4.5-.817-.826,3.057-3.09H1V12.209H15.787l-3.057-3.09Z"
          transform="translate(0 0)" class="fi-fill-brand-primary-default"/>
      </g>
    </svg>
    <span fiTranslation="BUTTON_BACK"></span>
  </a>
}
<div class="container">
  @if (!edittedOrgUnitSetting && orgUnitSettings.length) {
    <h2 class="main-title"><span fiTranslation="ADMINISTRATION_OU_OVERVIEW"></span> {{ mandant?.Name }}</h2>
    <div class="org-unit-list">
      @for (setting of orgUnitSettings; track setting; let i = $index) {
        <div class="item">
          <span class="name"> {{ setting.Description }} </span>
          @if (!setting.IsContactManagerOU && !setting.IsMandantAdminOU) {
            @if (contactTypes.length && leadTypes.length) {
              <button (click)="onEdit(i)"
                #edit [isTitle]="true"
                fiTranslation="ADMINISTRATION_EDIT" matTooltip="{{edit.dataset.matTooltip}}"
                matTooltipPosition="below" matTooltipClass='tooltip-style'
                ><img class="edit" alt="Edit" src="assets/icons/edit.svg">
                <span class="u-hidden-visually" fiTranslation="ADMINISTRATION_EDIT"></span>
              </button>
            }
            <button (click)="onDelete(i)"
              #delete [isTitle]="true"
              fiTranslation="ADMINISTRATION_DELETE" matTooltip="{{delete.dataset.matTooltip}}"
              matTooltipPosition="below" matTooltipClass='tooltip-style'
              >
              <img class="close" alt="Delete" src="assets/icons/close-icon.svg">
              <span class="u-hidden-visually" fiTranslation="ADMINISTRATION_DELETE"></span>
            </button>
          }
        </div>
      }
    </div>
  }

  @if (mandant && !edittedOrgUnitSetting) {
    <button class="new-btn" (click)="onCreate()">
      <img alt="Add org unit setting" src="/assets/icons/add-org-unit.svg">
      <span fiTranslation="ADMINISTRATION_OU_CREATE"></span>
    </button>
  }

  @if (edittedOrgUnitSetting && contactTypes.length && leadTypes.length) {
    <div class="edit-container">
      <span class="mandatory-text" fiTranslation="FORM_ERRORMSG_HEADLINE_MANDATORY_FIELDS"></span>
      <h2 class="edit-title"><span [fiTranslation]="edittedOrgUnitSetting.Id ? 'ADMINISTRATION_OU_EDIT' : 'ADMINISTRATION_OU_CREATE'"></span></h2>
      <div class="main-form">
        <div class="field">
          <p class="label-text">
            <span fiTranslation="ADMINISTRATION_OU_DESCRIPTION"></span>
          </p>
          <input maxlength="500" type="text" class="input-field" [(ngModel)]="edittedOrgUnitSetting.Name" [class.empty-field]="nameError" (change)="nameError = false">
        </div>
        <div class="field">
          <p class="label-text">
            <span fiTranslation="ADMINISTRATION_OU_SUPERIOR_OU"></span>
          </p>
          <div fiCustomSelect
            (value)="onParentChange($event)"
            [placeHolder]="selectedParentText"
            [data]="parentDropdownOptions"
            [dataValueKey]="'Id'"
            [dataNameKey]="'Description'"
            class="select-type select input-field">
            <span class="selected-value placeholder"></span>
            <img src="assets/icons/arrow-down-dark.svg" alt="icon" class="arrow">
            <div class="options-cont large">
              <ul class="options"></ul>
            </div>
          </div>
        </div>
        <div class="field">
          <p class="label-text">
            <span fiTranslation="ADMINISTRATION_OU_POSSIBLE_ENQUIRY_TYPES"></span>
          </p>
          <div fiCustomSelect
            [placeHolder]="selectedLeadsText"
            (value)="onSelectLeadTypes($event)"
            [isMultiSelect]="true"
            [selectedData]="selectedLeadTypes"
            [data]="leadTypes"
            [dataValueKey]="'Id'"
            [dataNameKey]="'Description'"
            class="select-type select input-field">
            <span class="selected-value placeholder"></span>
            <img src="assets/icons/arrow-down-dark.svg" alt="icon" class="arrow">
            <div class="options-cont large">
              <ul class="options"></ul>
            </div>
          </div>
        </div>
        <div class="field">
          <p class="label-text">
            <span fiTranslation="ADMINISTRATION_OU_BLOCK_CONTACTS_TYPES"></span>
          </p>
          <div fiCustomSelect
            [placeHolder]="selectedContactsText"
            (value)="onSelectContactTypes($event)"
            [isMultiSelect]="true"
            [selectedData]="selectedContactTypes"
            [data]="contactTypes"
            [dataValueKey]="'Id'"
            [dataNameKey]="'Description'"
            class="select-type select input-field">
            <span class="selected-value placeholder"></span>
            <img src="assets/icons/arrow-down-dark.svg" alt="icon" class="arrow">
            <div class="options-cont large">
              <ul class="options"></ul>
            </div>
          </div>
        </div>
        <div class="field">
          <p class="label-text">
            <span fiTranslation="ADMINISTRATION_OU_MANDANT"></span>
          </p>
          <input maxlength="500" type="text" readonly class="input-field read-only first" [value]="mandant.KKZ">
          <input maxlength="500" type="text" readonly class="input-field read-only last" [value]="mandant.Name">
        </div>
      </div>
      <div class="toggle-container">
        <fi-switch class="toggle-btn switch"
          [(ngModel)]="edittedOrgUnitSetting.SharedRead">
        </fi-switch>
        <div class="toggle-description">
          <span class="title" fiTranslation="ADMINISTRATION_OU_SHARED_READING_RIGHT"></span>
          <span class="description" fiTranslation="ADMINISTRATION_OU_SHARED_READING_RIGHT_DESCRIPTION"></span>
        </div>
      </div>
      <div class="footer">
        <button class="submit-btn" (click)="onSubmit()" [class.edit]="edittedOrgUnitSetting.Id">
          @if (edittedOrgUnitSetting.Id) {
            <img alt="Save" src="assets/icons/save-blue.svg">
          }
          @if (!edittedOrgUnitSetting.Id) {
            <img alt="Save" src="assets/icons/add-org-init-white.svg">
          }
          <span [fiTranslation]="edittedOrgUnitSetting.Id ? 'ADMINISTRATION_SAVE_CHANGES' : 'ADMINISTRATION_OU_BUTTON_CONFIRM_CREATION'"></span>
        </button>
      </div>
    </div>
  }
</div>


